export default __webpack_public_path__ + "static/Kenyasnewfoundlionprotectors-b0837fca10acde8944f3e6249db9460e.jpg";